<template>
  <div class="dialog clearfix">

    <div class="row">
      <div class="column">
        <!-- Open File: [ *.MSP ] -->
        <label>Open File:</label>
        <div class="fake-input">{{ selectedFile }}</div>
      </div>
    </div>
    <div class="row">
      <div class="column small-6">
        <ul class="open-files">
          <li><label>[-A-]</label></li>
          <li><label>[-B-]</label></li>
          <li><label>[-C-]</label></li>
          <li><label>[..]</label></li>
          <li v-bind:class="{selected: selectedFile==NINJACAT}" v-on:click="selectFile(NINJACAT)"><label>{{ NINJACAT }}</label></li>
          <li v-bind:class="{selected: selectedFile==WALLPAPER}" v-on:click="selectFile(WALLPAPER)"><label>{{ WALLPAPER }}</label></li>
        </ul>
      </div>
      <div class="column small-6">
        <label class="current-loc">C:\windows</label>
        <div class="dialog-buttons">
          <a href="/static/images/ninjacat-wallpaper-2016.png" target="_blank" download class="form-button" v-if="selectedFile==WALLPAPER"><div class="form-button-box"><label>Download</label></div></a>
          <div class="form-button" v-else v-on:click="openFile"><div class="form-button-box"><label>Open</label></div></div>
          <div class="form-button" data-cmd="closePalette" ><div class="form-button-box"><label>Cancel</label></div></div>
        </div>
      </div>
    </div>


  </div>
</template>

<style lang="scss" scoped>

  $w: 296px;

  .dialog {
    width: $w;

    .row {
      margin-top: 4px;
      margin-bottom: 4px;
    }

    .dialog-buttons {
      width: 100px;
      margin: 8px auto;
    }
  }

  .current-loc {
    margin: 0 0 10px 0;
    position: relative;
    top: -2px;
  }

  .open-files {
    background: url(../../assets/open_files.gif);
    width: 142px;
    height: 86px;
    background-size: 100% auto;

    list-style: none;
    padding: 0 15px 0 0;
    margin: 0;

    li {
      height: 15px;
      //overflow: hidden;
      padding: 0 4px 4px;
      margin-top: -1px;

      &.selected {
        background-color: #000;
        color: #fff;
      }
    }
  }

  a {
    color: #000;
  }



  .fake-input {
    display: inline-block;
    border: 1px solid black;
    margin: 0;
    padding: 1px 4px;
    color: #000;
    width: 190px;
    margin-bottom: 4px;
  }
</style>

<script>
  import state from '../../data/state';
  import config from '../../data/config';


  export default{
    data(){
      return {
        NINJACAT: 'NINJACAT.BMP',
        WALLPAPER: 'WALL2016.PNG',
        state,
        selectedFile: '*.BMP',
      }
    },

    methods: {
      selectFile(f) {
        if(!f) f = '*.BMP';
        this.selectedFile = f;
      },

      openFile() {

        switch(this.selectedFile) {

          case this.NINJACAT:
            window.paint.loadImage(config.overlayArtwork);
            state.title = this.NINJACAT;
            state.closePalette();
            break;

          case this.WALLPAPER:
            // download wallpaper
            state.closePalette();
            break;

        }

      }
    },

    ready() {
      this.selectFile(null);
    },


  }
</script>



// WEBPACK FOOTER //
// OpenDialog.vue?6c6e3b1a